import { type MachineContextType } from '#src/state-machine/types';
import {
  type ViewType,
  type Compare,
  type CompareBy,
  DefaultFilterValues,
} from '#src/types';

export function updateCompareBy(
  type: 'level' | 'category' | 'fundingSource',
  filterValue: string,
  compare: Compare | undefined,
  context: MachineContextType
) {
  const typeCompare: Compare = compare?.filter((c) => c.length > 0) || [];
  let compareBy = context.compareBy;
  const removeCompareBy =
    [
      DefaultFilterValues.level,
      DefaultFilterValues.category,
      DefaultFilterValues.fundingSource,
    ].includes(filterValue as DefaultFilterValues) || typeCompare.length === 1;

  if (compare && !removeCompareBy) {
    // we only add to compareBy if it's not already there
    // if we have it in compareBy, we don't want to change the position
    if (!compareBy.includes(type)) {
      compareBy = [...compareBy, type];
    }
  } else {
    // we remove it from compareBy if it's there
    compareBy = compareBy.filter((c) => c !== type);
  }

  const categoryValue = type === 'category' ? filterValue : context.category;
  compareBy = sanitizeCompareBy(compareBy, categoryValue, context.viewType);

  return {
    ...context,
    [type]: filterValue,
    compareBy,
    [`${type}Compare`]: typeCompare,
  };
}

export function sanitizeCompareBy(
  compareBy: CompareBy,
  categoryValue: string,
  viewType: ViewType
): CompareBy {
  if (
    // since earmarking has its own color ramp, we always want to display it as stacks
    // therefore, we need to make it the second dimension
    categoryValue === 'EMK' ||
    // for the table it was a product decision to fix the dimension
    // that displays as columns to always be the category,
    // at least until we have a button to toggle dimensions
    (compareBy.includes('category') && viewType === 'table')
  ) {
    return [...compareBy.filter((c) => c !== 'category'), 'category'];
  }

  return compareBy;
}
